import ApiService from '../../services/api.service';

export default {
  namespaced: true,
  state: {
    answers: {},
    isLoading: true,
    assessmentRevisionComplete: false,
    existingAssessment: {},
    pdfFile: null,
    excludedAttributes: [
      'archived',
      'archived_at',
      'created_at',
      'created_by',
      'dealer_id',
      'id',
      'last_updated_by',
      'updated_at',
      'uuid',
    ],
    attributeMappings: {
      q1_s1: 'q1',
      q2_s1_a: 'q2_s1',
      q2_s1_b: 'q2_s1_followup',
      q2_s2_a: 'q2_s2',
      q2_s2_b: 'q2_s2_followup',
      q2_s3: 'q2_s3',
      q2_s4: 'q2_s4',
      q2_s5: 'q2_s5',
      q2_s6: 'q2_s5_followup',
      q2_s7: 'q2_s6',
      q3_s2: 'q3_s1',
      q3_s3: 'q3_s2',
      q3_s4: 'q3_s3',
      q3_s5: 'q3_s4',
      q3_s6_a: 'q3_s5_a',
      q3_s6_b: 'q3_s5_b',
      q3_s7_a: 'q3_s6_a',
      q3_s7_b: 'q3_s6_b',
      q3_s8: 'q3_s7',
      q5_s1: 'q4_s1',
      q5_s2: 'q4_s2',
      q5_s3: 'q4_s3',
      q5_s4: 'q4_s4',
      q6_s1: 'q6_s1',
      q6_s2: 'q6_s2',
      q6_s3: 'q6_s3',
      q7_s1_a: 'q5',
      q7_s1_b: 'q5_s2',
      q7_s1_c: 'q5_s3',
      q7_s1_d: 'q5_s4',
      q7_s1_e: 'q5_s5',
      q7_s1_f: 'q5_s6',
      q7_s2_a: 'q5_s8',
      q7_s2_b: 'q5_s9',
      q7_s2_c: 'q5_s10',
      q7_s2_d: 'q5_s11',
      q7_s2_e: 'q5_s12',
      q8: 'q7_s0',
      q8_s1_a: 'q7_s1',
      q8_s1_b: 'q7_s1_followup',
      q8_s1_c: 'q7_s2',
      q8_s2: 'q7_s3',
      q8_s3: 'q7_s4',
      q8_s4: 'q7_s5',
      q8_s5: 'q7_s6',
      q8_s6: 'q7_s7',
      q8_s7: 'q7_s7_followup',
      q9_s1_a: 'q8_s1',
      q9_s1_b: 'q8_s2',
      q9_s2_followup: 'q8_s2_followup',
      q9_s1_c: 'q8_s3_a',
      q9_s1_d: 'q8_s3_b',
      q9_s1_e: 'q8_s4_a',
      q9_s1_f: 'q8_s4_b',
      q9_s1_g: 'q8_s5',
      q9_s1_h: 'q8_s6',
      q9_s1_i: 'q8_s7',
      q9_s2_a: 'q8_s8',
      q9_s2_b: 'q8_s8_followup_negative',
      q9_s3: 'q8_s9',
      q9_s4: 'q8_s10',
      q9_s5: 'q8_s11',
      additional_ideas: 'additional_ideas',
      dealership_specific_notes: 'dealership_specific_notes',
      q2_s1_followup_negative: 'q2_s1_followup_negative',
      q2_s2_followup_negative: 'q2_s2_followup_negative',
      q2_s3_followup_negative: 'q2_s3_followup_negative',
      q2_s4_followup_negative: 'q2_s4_followup_negative',
      q2_s5_followup_negative: 'q2_s5_followup_negative',
      q2_s6_followup_negative: 'q2_s6_followup_negative',
      q3_s7_followup_negative: 'q3_s7_followup_negative',
      q5_s1_followup_negative: 'q4_s1_followup_negative',
      q5_s2_followup_negative: 'q4_s2_followup_negative',
      q7_s4_followup_negative: 'q5_s4_followup_negative',
      q7_s5_followup_negative: 'q5_s5_followup_negative',
      q7_s9_followup_negative: 'q5_s9_followup_negative',
      q7_s10_followup_negative: 'q5_s10_followup_negative',
      q7_s11_followup_negative: 'q5_s11_followup_negative',
      q8_s0_followup_negative: 'q7_s0_followup_negative',
      q8_s1_followup_negative: 'q7_s1_followup_negative',
      q8_s4_followup_negative: 'q7_s4_followup_negative',
      q8_s5_followup_negative: 'q7_s5_followup_negative',
      q8_s6_followup_negative: 'q7_s6_followup_negative',
      q8_s7_followup_negative: 'q7_s7_followup_negative',
      q9_s2_followup_negative: 'q8_s2_followup_negative',
      q9_s7_followup_negative: 'q8_s7_followup_negative',
      q9_s11_followup_negative: 'q8_s11_followup_negative',
      q2_s1_followup_1: 'q2_s1_followup_1',
      q2_s2_followup_1: 'q2_s2_followup_1',
      q9_s6: 'q9_s6',
      q9_s7: 'q9_s7',
      q9_s8: 'q9_s8',
      q9_s8_followup_negative: 'q9_s8_followup_negative',
      q3_s9: 'q3_s9',
      q3_s10: 'q3_s10',
      q3_s11: 'q3_s11',
      q4_s3: 'q4_s3',
      q4_s4: 'q4_s4',
      q4_s5: 'q4_s5',
      q4_s6: 'q4_s6',
      q4_s7: 'q4_s7',
      q8_s13: 'q8_s13',
      q8_s13_followup_negative: 'q8_s13_followup_negative',
      q8_s14: 'q8_s14',
      q8_s19: 'q8_s19',
    },
    validatedFields: {
      q2_s1: true,
      q2_s1_followup: true,
      q2_s1_followup_1: true,
      q2_s1_followup_negative: true,
      q2_s2: true,
      q2_s2_followup: true,
      q2_s2_followup_1: true,
      q2_s2_followup_negative: true,
      q2_s3: true,
      q2_s3_followup_negative: true,
      q2_s4: true,
      q2_s4_followup_negative: true,
      q2_s5: true,
      q2_s5_followup: true,
      q2_s5_followup_negative: true,
      q2_s6: true,
      q2_s6_followup_negative: true,
      q3_s2: true,
      q3_s3: true,
      q3_s6: true,
      q3_s6_a: true,
      q3_s6_b: true,
      q3_s7: true,
      q3_s7_followup_negative: true,
      q3_s9: true,
      q3_s10: true,
      q3_s11: true,
      q9_s6: true,
      q9_s7: true,
      q9_s8: true,
      q9_s8_followup_negative: true,
    },
  },

  mutations: {
    SET_ANSWER(state, { key, value }) {
      state.answers = {
        ...state.answers,
        [key]: value,
      };
      console.log('key', key);
    },
    SET_LOADING(state, isLoading) {
      state.isLoading = isLoading;
    },
    RESET_ANSWERS(state) {
      state.answers = {};
    },
    SET_ANSWERS(state, answers) {
      state.answers = answers;
    },
    SET_EXISTING_ASSESSMENT(state, value) {
      state.existingAssessment = value;
    },
    SET_ASSESSMENT_REVISION_COMPLETE(state, value) {
      state.assessmentRevisionComplete = value;
    },
    SET_PDF_FILE(state, value) {
      state.pdfFile = value;
    },
  },

  actions: {
    updateAnswer({ commit }, { id, value }) {
      commit('SET_ANSWER', { key: id, value });
    },

    updatePdfFile({ commit }, pdfFile) {
      commit('SET_PDF_FILE', pdfFile);
    },

    updateAssessmentRevisionComplete({ commit }, value) {
      commit('SET_ASSESSMENT_REVISION_COMPLETE', value);
    },

    async checkExistingAssessment({ commit, dispatch }, currentDealership) {
      let params = {
        'q[dealer_id_eq]': currentDealership.id,
        'q[s]': 'created_at desc',
      };

      await ApiService.query('retail_traffic_assessments', { params }).then(
        (response) => {
          if (response.data && response.data.length > 0) {
            commit('SET_EXISTING_ASSESSMENT', response.data[0]);
            dispatch('updateAssessmentAnswers');
          } else {
            commit('SET_EXISTING_ASSESSMENT', null);
            commit('RESET_ANSWERS', null);
            commit('SET_LOADING', false);
          }
        }
      );
    },

    async submitAssessment({ state, dispatch, commit }, currentDealership) {
      // Reverse the key mappings so the backend gets the data in the expected format
      const reversedMappings = Object.fromEntries(
        Object.entries(state.attributeMappings).map(
          ([backendKey, frontendKey]) => [frontendKey, backendKey]
        )
      );

      const updatedAnswers = {};

      // Map values back to expected backend keys
      Object.entries(state.answers).forEach(([frontendKey, value]) => {
        const backendKey = reversedMappings[frontendKey] || frontendKey;

        let newValue = value;
        if (value === 'true') newValue = true;
        else if (value === 'false') newValue = false;

        updatedAnswers[backendKey] = newValue;
      });

      // Check if we have an existing assessment we can update
      if (state.existingAssessment) {
        await ApiService.update(
          `retail_traffic_assessments`,
          state.existingAssessment.id,
          {
            retail_traffic_assessment: updatedAnswers,
          }
        )
          .then(() => {
            // Check if user has a pdf to upload
            if (state.pdfFile) {
              let params = new FormData();
              params.append('retail_traffic_assessment[pdf]', state.pdfFile);

              return ApiService.uploadFile(
                `retail_traffic_assessments/${state.existingAssessment.id}`,
                params
              );
            }
            return null;
          })
          .then(() => {
            commit('SET_PDF_FILE', null);
            dispatch('checkExistingAssessment', currentDealership);
          });
      } else {
        // Create new assessment
        let params = { ...updatedAnswers };
        params.dealer_id = currentDealership.id;

        await ApiService.post('retail_traffic_assessments', {
          retail_traffic_assessment: params,
        })
          .then((response) => {
            const retailTrafficAssessment = response.data;

            // Check if user has a pdf to upload
            if (state.pdfFile) {
              let params = new FormData();
              params.append('retail_traffic_assessment[pdf]', state.pdfFile);

              return ApiService.uploadFile(
                `retail_traffic_assessments/${retailTrafficAssessment.id}`,
                params
              );
            }
            return null;
          })
          .then(() => {
            commit('SET_PDF_FILE', null);
            dispatch('checkExistingAssessment', currentDealership);
          });
      }

      return state.existingAssessment;
    },

    updateAssessmentAnswers({ commit, state }) {
      // Map the existing assessment to match the expected format of the frontend answers
      const result = {};

      Object.entries(state.existingAssessment).forEach(([key, value]) => {
        if (state.excludedAttributes.includes(key)) return;

        const newKey = state.attributeMappings[key] || key;
        result[newKey] = typeof value === 'boolean' ? String(value) : value;
      });

      commit('SET_ANSWERS', result);
      commit('SET_LOADING', false);
    },

    async generateAssessmentRevision({ state, commit }) {
      let params = {
        retail_traffic_assessment_id: state.existingAssessment.id,
      };

      await ApiService.post('retail_traffic_assessment_revisions', {
        retail_traffic_assessment_revision: params,
      }).then(() => {
        commit('SET_ASSESSMENT_REVISION_COMPLETE', true);
      });
    },
    runValidation({ state }) {
      for (const key in state.validatedFields) {
        state.validatedFields[key] =
          state.answers[key] !== null && state.answers[key] !== undefined;

        // One offs (Depending on yes/no sometimes we have info text that we don't want to validate)
        if (key === 'q2_s1_followup') {
          if (
            state.answers['q2_s1'] === 'true' &&
            state.answers[key] !== null &&
            state.answers[key] !== ''
          ) {
            state.validatedFields[key] = true;
          } else
            state.validatedFields[key] = state.answers['q2_s1'] === 'false';
        }

        if (key === 'q2_s1_followup_1') {
          if (
            state.answers['q2_s1'] === 'true' &&
            state.answers[key] !== null &&
            state.answers[key] !== '' &&
            state.answers[key] !== undefined
          ) {
            state.validatedFields[key] = true;
          } else
            state.validatedFields[key] = state.answers['q2_s1'] === 'false';
        }

        if (key === 'q2_s1_followup_negative') {
          if (
            state.answers['q2_s1'] === 'false' &&
            state.answers[key] !== null &&
            state.answers[key] !== ''
          ) {
            state.validatedFields[key] = true;
          } else {
            state.validatedFields[key] = state.answers['q2_s1'] === 'true';
          }
        }

        if (key === 'q2_s2_followup') {
          if (
            state.answers['q2_s2'] === 'true' &&
            state.answers[key] !== null &&
            state.answers[key] !== ''
          ) {
            state.validatedFields[key] = true;
          } else
            state.validatedFields[key] = state.answers['q2_s2'] === 'false';
        }

        if (key === 'q2_s2_followup_1') {
          if (
            state.answers['q2_s2'] === 'true' &&
            state.answers[key] !== null &&
            state.answers[key] !== '' &&
            state.answers[key] !== undefined
          ) {
            state.validatedFields[key] = true;
          } else
            state.validatedFields[key] = state.answers['q2_s2'] === 'false';
        }

        if (key === 'q2_s2_followup_negative') {
          if (
            state.answers['q2_s2'] === 'false' &&
            state.answers[key] !== null &&
            state.answers[key] !== ''
          ) {
            state.validatedFields[key] = true;
          } else {
            state.validatedFields[key] = state.answers['q2_s2'] === 'true';
          }
        }

        if (key === 'q2_s3_followup_negative') {
          if (
            state.answers['q2_s3'] === 'false' &&
            state.answers[key] !== null &&
            state.answers[key] !== ''
          ) {
            state.validatedFields[key] = true;
          } else {
            state.validatedFields[key] = state.answers['q2_s3'] === 'true';
          }
        }

        if (key === 'q2_s4_followup_negative') {
          if (
            state.answers['q2_s4'] === 'false' &&
            state.answers[key] !== null &&
            state.answers[key] !== ''
          ) {
            state.validatedFields[key] = true;
          } else {
            state.validatedFields[key] = state.answers['q2_s4'] === 'true';
          }
        }

        if (key === 'q2_s5_followup') {
          if (
            state.answers['q2_s5'] === 'true' &&
            state.answers[key] !== null &&
            state.answers[key] !== ''
          ) {
            state.validatedFields[key] = true;
          } else
            state.validatedFields[key] = state.answers['q2_s5'] === 'false';
        }

        if (key === 'q2_s5_followup_negative') {
          if (
            state.answers['q2_s5'] === 'false' &&
            state.answers[key] !== null &&
            state.answers[key] !== ''
          ) {
            state.validatedFields[key] = true;
          } else {
            state.validatedFields[key] = state.answers['q2_s5'] === 'true';
          }
        }

        if (key === 'q2_s6_followup_negative') {
          if (
            state.answers['q2_s6'] === 'false' &&
            state.answers[key] !== null &&
            state.answers[key] !== ''
          ) {
            state.validatedFields[key] = true;
          } else {
            state.validatedFields[key] = state.answers['q2_s6'] === 'true';
          }
        }

        state.validatedFields['q3_s6'] =
          state.answers['q3_s6_a'] !== null &&
          state.answers['q3_s6_a'] !== '' &&
          state.answers['q3_s6_b'] !== null &&
          state.answers['q3_s6_b'] !== '';

        if (key === 'q3_s7_followup_negative') {
          if (
            state.answers['q3_s7'] === 'false' &&
            state.answers[key] !== null &&
            state.answers[key] !== ''
          ) {
            state.validatedFields[key] = true;
          } else {
            state.validatedFields[key] = state.answers['q3_s7'] === 'true';
          }
        }

        if (key === 'q9_s8_followup_negative') {
          if (
            state.answers['q9_s8'] === 'false' &&
            state.answers[key] !== null &&
            state.answers[key] !== ''
          ) {
            state.validatedFields[key] = true;
          } else {
            state.validatedFields[key] = state.answers['q9_s8'] === 'true';
          }
        }
      }

      console.log(state.validatedFields);

      return Object.values(state.validatedFields).every(
        (value) => value === true
      );
    },
  },

  getters: {
    getAnswer: (state) => (key) => {
      const value = state.answers[key];
      return value !== undefined ? value : '';
    },
    isValid: (state) => (key) => {
      const value = state.validatedFields[key];
      if (value !== undefined && value !== null) {
        return value;
      }
      return true;
    },
  },
};
